import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  oauthRequestApiRef,
  oneloginAuthApiRef,
} from '@backstage/core-plugin-api';
import {
  activityLogApiRef,
  ActivityLogClientImpl,
} from '@internal/plugin-activity-log';
import OneLoginAuth from './implementations/OneLoginAuth';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: oneloginAuthApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OneLoginAuth.create({
        discoveryApi,
        oauthRequestApi,
        defaultScopes: ['openid', 'email', 'profile', 'params'],
        environment: configApi.getString('auth.environment'),
      }),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: activityLogApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new ActivityLogClientImpl({ discoveryApi, fetchApi }),
  }),
];
